import { eTongHopThongKeActionsObj } from "../../action-types/tong-hop-thong-ke/ITongHopThongKeActions";
import { generateActions } from "../generateActions";

export const tongHopThongKeActions = {
    ...generateActions(eTongHopThongKeActionsObj, "TONG_HOP_THONG_KE"),
}